module.exports = __webpack_public_path__ + "static/media/8OLA32.9fc086ee.jpg";